import { FileDetails } from "@/redux/feature/createOrder/scriptDetails/scriptDetailsSlice";
import { apiClient } from "@/services/apiServices";
import imageCompression from "browser-image-compression";
import { sanitizeFileName } from "./sanitizeFileName";

const bucket_names_with_cdn = [
  {
    cdn_base_url: "https://assets.passionbits.io",
    s3_bucket_names: ["passionbits-core-files"],
  },
];

const getCdnBaseUrl = (bucket_name: string) => {
  for (const item of bucket_names_with_cdn) {
    if (item.s3_bucket_names.includes(bucket_name)) {
      return item.cdn_base_url;
    }
  }
  return null;
};

export const UploadFileToS3 = async (
  file: FileDetails,
  bucket_name?: string
): Promise<FileDetails> => {
  try {
    // sanitize the name
    const sanitizedName = sanitizeFileName(file?.name as string);

    const key = `creator-dashboard-files/${sanitizedName}`;
    const payload = {
      fileName: key,
      fileType: file.type,
      bucket_name: bucket_name || "passionbits-core-files",
    };
    const response = await apiClient.post("/upload/get-presigned-url", payload);

    const presignedUrl = response.data;

    // Convert the blob URL to actual File object
    let instanceOfFile = await createFileFromBlobUrl({ file });

    // Compress and convert to WebP
    const isImage = file.type.startsWith("image/");
    if (isImage) {
      instanceOfFile = await imageCompression(instanceOfFile, {
        maxSizeMB: 0.5, // 500KB
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        fileType: "image/webp", // Convert to webp
      });
    }

    const uploadResponse = await fetch(presignedUrl.data, {
      method: "PUT",
      body: instanceOfFile,
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file");
    }

    let file_live_url;

    // check if the bucket is connect with cdn or not
    const cdn_base_url = getCdnBaseUrl(payload.bucket_name);

    if (cdn_base_url) {
      console.log("found cdn ", cdn_base_url);
      // if it finds any cdn url then use that
      file_live_url = `${cdn_base_url}/${payload.fileName}`;
      console.log(file_live_url);
    } else {
      console.log("coudnt found the cdn ", cdn_base_url);

      // else can use the default url
      file_live_url = presignedUrl.data.split("?")[0];
    }

    return {
      name: key,
      size: file.size,
      type: file.type,
      lastModified: file.lastModified,
      webkitRelativePath: file?.webkitRelativePath,
      local_url: file?.local_url,
      live_url: file_live_url,
    };
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};

async function createFileFromBlobUrl({
  file,
}: {
  file: {
    local_url: string;
    name: string;
    lastModified: number;
    type: string;
  };
}): Promise<File> {
  const response = await fetch(file.local_url);
  const blob = await response.blob();

  return new File([blob], file.name, {
    lastModified: file.lastModified,
    type: file.type,
  });
}
